import { render, staticRenderFns } from "./ctccGdAuth.vue?vue&type=template&id=e6979558&"
import script from "./ctccGdAuth.vue?vue&type=script&lang=js&"
export * from "./ctccGdAuth.vue?vue&type=script&lang=js&"
import style0 from "./ctccGdAuth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports